import { render, staticRenderFns } from "./Adesoes.vue?vue&type=template&id=5f2d8c10"
import script from "./Adesoes.vue?vue&type=script&lang=js"
export * from "./Adesoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports